import { Controller } from "@hotwired/stimulus";
import Pickr from "@simonwep/pickr";
import { backofficePath } from "../backoffice/backoffice_path";

export default class extends Controller {
  static targets = ["element", "input", "clear", "hexPreview", "divPreview", "eyeDropper"];

  connect() {    
    const input = this.inputTarget;
    const clearButton = this.clearTarget;
    const hexPreview = this.hexPreviewTarget;
    const circlePreview = this.divPreviewTarget;
    const eyeDropper = this.eyeDropperTarget;

    hexPreview.innerHTML = input.value || 'Transparent';
    circlePreview.style.backgroundColor = input.value;

    clearButton.addEventListener("click", function (e) {
      const color = "#e5e7eb";
      this.setInputValue(input, color);
      circlePreview.style.backgroundColor = color;

      e.preventDefault();
    });

    if (!window.EyeDropper) {
      eyeDropper.classList.add('hidden')
    } else {
      eyeDropper.addEventListener("click", () => {
        this.startEyeDropper(input, hexPreview, circlePreview)
      });
    }

    Pickr.create({
      el: this.elementTarget,
      theme: "nano",
      comparison: false,
      default: input.value,
      useAsButton: true,
      swatches: [
        "rgb(245, 246, 250)",
        "rgb(220, 221, 225)",
        "rgb(127, 143, 166)",
        "rgb(113, 128, 147)",
        "rgb(53, 59, 72)",
        "rgb(47, 54, 64)",
        "rgb(25, 42, 86)",
        "rgb(244, 67, 54)",
        "rgb(233, 30, 99)",
        "rgb(156, 39, 176)",
        "rgb(103, 58, 183)",
        "rgb(63, 81, 181)",
        "rgb(33, 150, 243)",
        "rgb(3, 169, 244)",
        "rgb(0, 188, 212)",
        "rgb(0, 150, 136)",
        "rgb(76, 175, 80)",
        "rgb(139, 195, 74)",
        "rgb(205, 220, 57)",
        "rgb(255, 235, 59)",
        "rgb(255, 193, 7)",
      ],
      components: {
        preview: true,
        opacity: false,
        hue: false,
        interaction: {
          hex: false,
          rgba: false,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: true,
          clear: false,
          save: false,
        },
      },
    }).on("change", (color) => {
      this.setInputValue(input, color.toHEXA());

      hexPreview.innerHTML = color.toHEXA()
      circlePreview.style.backgroundColor = color.toHEXA()

      this.updateCustomBackground(input, color.toHEXA());
      this.updateCustomTextColor(input, color.toHEXA());

      if (input.classList.contains("has-apply-all-link")) {
        const applyAllLink = input.parentElement.parentElement.querySelector(".apply-all-link")

        applyAllLink.href = `${backofficePath("/button_settings/apply_all")}?column_name=${
          applyAllLink.getAttribute('name')
        }&column_value=${color.toHEXA().toString().replaceAll("#", "")}`;
      }
    });
  }

  updateCustomBackground(input, color) {
    const elements = document.getElementsByClassName(`${input.id}-as-background-color`);
    this.styleAdditionalElements(elements, color, 'backgroundColor');
  };

  updateCustomTextColor(input, color) {
    const elements = document.getElementsByClassName(`${input.id}-as-text-color`);
    this.styleAdditionalElements(elements, color, 'color');
  };

  styleAdditionalElements(elements, color, attr) {
    if (elements[0] === undefined) return;

    for (var i = 0; i !== elements.length; i++) {
      elements[i].style[attr] = color;
    }
  };

  startEyeDropper(input, hexPreview, circlePreview) {
    const eyeDropper = new EyeDropper();

    eyeDropper
      .open()
      .then((result) => {
        this.setInputValue(input, result.sRGBHex);

        hexPreview.innerHTML = result.sRGBHex
        circlePreview.style.backgroundColor = result.sRGBHex

        this.updateCustomBackground(input, result.sRGBHex);
        this.updateCustomTextColor(input, result.sRGBHex);
      })
      .catch((e) => {
        console.log("Something went wrong...")
      });
  };

  setInputValue(input, value) {
    input.value = value;
    input.dispatchEvent(new Event("input", { bubbles: true }));
  };
};
